import { render, staticRenderFns } from "./AdmissionResult.vue?vue&type=template&id=ceb18814&scoped=true&"
import script from "./AdmissionResult.vue?vue&type=script&lang=ts&"
export * from "./AdmissionResult.vue?vue&type=script&lang=ts&"
import style0 from "./AdmissionResult.vue?vue&type=style&index=0&id=ceb18814&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb18814",
  null
  
)

export default component.exports